import React, { useState, useEffect, useRef } from "react"
import { useSelector } from 'react-redux'
import { cloneObj, getClientId, getSiteGid, initFeClient, getRoomGid } from 'src/_helpers'
import { ClientForm } from './Form'
import { ListMsg } from './List'
import { DirectMessagingFEService } from 'src/_services'

export const ListMessages = ({ item, isOpen, ...props }) => {
  const messagesEndRef = useRef(null)
  const [formData, setFormData] = useState({})
  const [type, setType] = useState(0)
  const [msg, setMsg] = useState(null)
  const [clientInfo, setClientInfo] = useState({})
  const [isTyping, setTyping] = useState(null)
  const DMStore = useSelector((state) => state.DirectMessaging);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom()
  }, [isOpen]);
  useEffect(() => {
    if (DMStore) {
      setFormData({ ...cloneObj(DMStore) })
      if (DMStore.status === 'NEW') {
        setType(1)
      } else {
        setClientInfo(DMStore)
      }
    }
    scrollToBottom()
  }, [DMStore]);
  useEffect(() => {
    if (type === 3) {
      new DirectMessagingFEService()
        .join(getSiteGid(), getRoomGid(), clientInfo)
        .then((rep) => {
          initFeClient({
            message: [],
            client_id: getClientId(),
            ...clientInfo,
            status: 'DONE',
            token: rep.data
          })
          setClientInfo({
            ...clientInfo,
            status: 'DONE',
            token: rep.data
          })
        })
    }
  }, [type]);
  const send = () => {
    if (!msg) return
    if (formData.status === 'NEW') {
      if (type === 1) {
        setClientInfo({
          ...clientInfo,
          customer_name: msg
        })
        setType(2)
      }
      if (type === 2) {
        setClientInfo({
          ...clientInfo,
          customer_phone: msg
        })
        setType(3)
      }
      setMsg('')
    }
    if (formData.status === 'DONE') {
      new DirectMessagingFEService()
        .send(getSiteGid(), { message: msg, type: props.type || 1 })
        .then(() => {
          setMsg('')
          scrollToBottom()
        })
    }
  }
  const setValue = (e) => {
    setMsg(e.target.value)
  }
  const message = DMStore?.message
  return (
    <div className="contact-detail">
      <div className="contact bar">
        <div className="pic">{item.room}</div>
        <div className="name">
          {item.name}
        </div>
        <div className="seen">
          {item.last_date_time}
        </div>
        <div className='close-btn' onClick={() => props.onClose()}>
          <i className="fas fa-times fa-1x"></i>
        </div>
      </div>
      <div className="messages" id="chat">
        <ClientForm type={type} clientInfo={clientInfo} />
        <ListMsg message={message} />
        {isTyping &&
          <div className="message stark">
            <div className="typing typing-1"></div>
            <div className="typing typing-2"></div>
            <div className="typing typing-3"></div>
          </div>
        }
        <div ref={messagesEndRef} />
      </div>
      <div className="input">
        {/* <i className="fas fa-camera"></i><i className="far fa-laugh-beam"></i> */}
        <input placeholder="Type your message here!" value={msg || ''} type="text" onChange={(e) => setValue(e)} /><i onClick={() => send()} className="fas fa-paper-plane"></i>
      </div>
    </div>
  );
};
